import commonFun from "@/utils/commonFun";
import commonMethods from "@/utils/commonMethods";

export default {
    data() {
        return {
            pageSizeList: [15, 50, 100, 1000],
        }
    },
    extends: commonMethods,
    methods: {
        //页码变化
        pageNumberChange(val, formKey, queryMethod) {
            let that = this;
            if (commonFun.isEmpty(formKey)) {
                formKey = 'queryCondition';
            }
            if (commonFun.isEmpty(queryMethod)) {
                queryMethod = 'queryData';
            }
            that.$data[formKey].pageNum = val;
            that[queryMethod]();
        },
        //显示条数变更
        pageSizeChange(val, formKey, queryMethod) {
            let that = this;
            if (commonFun.isEmpty(formKey)) {
                formKey = 'queryCondition';
            }
            if (commonFun.isEmpty(queryMethod)) {
                queryMethod = 'queryData';
            }
            that.$data[formKey].pageSize = val;
            that[queryMethod]();
        },
        //查询条件重置方法
        restQueryForm: function(formKey) {
            if (typeof formKey == 'object' || commonFun.isEmpty(formKey)) {
                formKey = 'queryCondition';
            }
            console.log(1);
            this.$refs[formKey].resetFields();
            this.$data[formKey].pageSize = 15;
            this.$data[formKey].pageNum = 1;
        }
    }
}
